<div>
  <div mat-dialog-title align='center'>
    <img src='/assets/images/logo-black-2.png' height='100px'>
  </div>
  <div align='center' *ngIf='loginWithEmail' style='padding-bottom:15px'>
    <div mat-dialog-content>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="email" placeholder="Email" required>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input matInput [(ngModel)]="password" type="password" placeholder="Password" (keydown.enter)='onLogin()'
          required>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align='center'>
      <button mat-raised-button color='accent' (click)="onLogin()" tabindex="2">login
        <i *ngIf='sendingRequest' class='fa fa-spinner fa-spin fa-fw'></i>
      </button>
      <button mat-button (click)="onNoClick()" tabindex="-1">cancel</button>
    </div>
  </div>

  <div mat-dialog-content *ngIf="error" class='warn-color s18-font'>Unable to login, please try again later.</div>
  <button class='facebook-button' style='width:100%' mat-raised-button (click)='signInWithFB()'>
    <div class="social-btn-layout">
      <div class="social-btn-icon">
        <img src="assets\images\facebook-white.png" width='18px'>
      </div>
      <div class="social-btn-text">Sign in with Facebook</div>
    </div>
  </button>
  <button color='warn' style='width:100%' mat-raised-button disabled *ngIf="loginWithGoogle">
    <div class="social-btn-layout">
      <div class="social-btn-text">Signing in with Google...</div>
    </div>
  </button>
  <div class="google-btn-wrap" *ngIf="!loginWithGoogle">
    <asl-google-signin-button type="standard" size="large" text="signin_with" theme="outline" width="400"></asl-google-signin-button>
  </div>
  <!-- TODO: Unhide Apple Sign-In once Apple Developer account is reconnected -->
  <!-- <button class='apple-button' style='width:100%' mat-raised-button (click)='signInWithApple()' *ngIf="!loginWithApple">
    <div class="social-btn-layout">
      <div class="social-btn-icon">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.71 14.535c-.685.96-1.44 1.905-2.565 1.92-1.125.015-1.485-.66-2.775-.66-1.29 0-1.695.645-2.76.675-1.095.03-1.935-1.035-2.625-1.995C1.59 12.42.735 9.03 2.175 6.72c.72-1.14 2.01-1.875 3.405-1.89 1.08-.015 2.1.72 2.76.72.66 0 1.905-.9 3.21-.765.54.03 2.085.225 3.075 1.635-.075.045-1.83 1.08-1.815 3.21.015 2.55 2.22 3.39 2.25 3.405-.015.045-.345 1.215-1.155 2.4l.015.015-.015-.015zM10.665 3.54c.57-.705.96-1.665.855-2.64-.825.03-1.83.555-2.43 1.26-.54.63-.99 1.62-.87 2.565.915.075 1.86-.465 2.445-1.185z" fill="white"/>
        </svg>
      </div>
      <div class="social-btn-text">Sign in with Apple</div>
    </div>
  </button>
  <button color='warn' style='width:100%' mat-raised-button disabled *ngIf="loginWithApple">
    <div class="social-btn-layout">
      <div class="social-btn-text">Signing in with Apple...</div>
    </div>
  </button> -->
  <button color='' style='width:100%' mat-raised-button class='email-button' (click)='loginWithEmail = !loginWithEmail'>
    <div class="social-btn-layout">
      <div class="social-btn-icon">
        <i class='fa fa-envelope'></i>
      </div>
      <div class="social-btn-text">Sign in with Email</div>
    </div>
  </button>
  <div style='text-align: center'>
    <p>Don't have an account?
      <a style='cursor: pointer; text-decoration-color:green; color: green' (click)='forwardToCreate()'>Create one
        here</a>
    </p>
  </div>
</div>
